import { Component, Input, OnInit } from '@angular/core';
import { Participante } from 'src/app/interfaces/datos-firma-interface';

@Component({
  selector: 'app-firmantes',
  templateUrl: './firmantes.component.html',
  styleUrls: ['./firmantes.component.css']
})
export class FirmantesComponent implements OnInit {

  @Input() firmantes: Participante[];
  constructor() { }

  ngOnInit(): void {    
  }

  ngOnChanges(): void {
    // aca se cargan los valores validando primero la entrada
  }
}
